var AdministratorItem;

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import UserModal from 'trunks/vue/admin/compositions/organization_modal/application_user_modal.js';

export default AdministratorItem = {
  components: {
    'user-item': UserItem,
    'Popover': Popover
  },
  props: {
    administrator: {
      type: Object
    },
    resources: {
      type: String
    },
    accessesList: {
      type: Array
    },
    organization: {
      type: Object
    }
  },
  data: function() {
    return {
      profileSchema: null
    };
  },
  computed: {
    founded: function() {
      return this.administrator.access.founded;
    },
    user: function() {
      return this.administrator.user;
    }
  },
  template: `<div class="administrator-item-wrapper">
  <div class="administrator-item mb-5">
    <div class="administrator-wrapper">
      <div class="administrator-user-title mb-1">姓名</div>
      <div class="administrator-user-info"  @click.stop="showUserInfoModal">
        <user-item :user="administrator.user"/>
      </div>
    </div>
    <div class="administrator-wrapper text-over">
      <div class="administrator-user-title mb-2">识别码/手机号</div>
      <div class="administrator-user-info">
        <div class="user-info">{{administrator.user.identifier}}/{{administrator.user.phone}}</div>
      </div>
    </div>
    <div class="administrator-wrapper">
      <div class="administrator-user-title mb-2">角色管理</div>
      <div class="administrator-user-info">
        <div class="user-info access">
          <div class="access" v-if="founded">{{administrator.access.name}}</div>
          <Popover customClass="administrator-popover"
                   :loadContent="true"
                   size="small"
                   position="bottom center"
                   ref="popover" v-else>
            <template slot="trigger">
              <span class="mr-1">{{administrator.access.name}}</span>
              <i class="slp-chevron-down"></i>
            </template>
            <template slot="content">
              <div class="list">
                <template v-for="access in accessesList">
                  <div class="list-item" @click.stop="accessChange(access)">{{access.name}}</div>
                </template>
              </div>
            </template>
          </Popover>
        </div>
      </div>
    </div>
    <div class="administrator-wrapper" v-if="!administrator.access.founded">
      <div class="administrator-user-title mb-2">操作</div>
      <div class="administrator-user-info">
        <Popover position="bottom center"
                 :caret='true'
                 type="confirm"
                 size="default"
                 ref='deletePopoverRef'>
          <span class='normal-action' slot='trigger'>
            <button class="text-btn btn-danger">移除</button>
          </span>
          <div class="popover-confirm-content" slot="content">
            <div class="popover-confirm-title">确认移除成员</div>
            <div class="popover-confirm-footer">
              <div class="btn btn-default btn-small" @click='closeDeletePopover'>取消</div>
              <div class="btn btn-danger btn-small" @click='deleteAdministrator'>删除</div>
            </div>
          </div>
        </Popover>
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    return Skylark.Libs.Ajax.get("/admin/user_profile/schema.json", {
      responseType: 'json',
      success: (profileSchema) => {
        return this.profileSchema = profileSchema;
      }
    });
  },
  methods: {
    accessChange: function(access) {
      var data;
      data = {
        administrator_relationship: {
          access_id: access.id,
          user_id: this.user.id
        }
      };
      this._updateAccess(data, access);
      return this.$refs.popover.close();
    },
    closeDeletePopover: function() {
      return this.$refs.deletePopoverRef.close();
    },
    deleteAdministrator: function() {
      this.closeDeletePopover();
      return Skylark.Libs.Ajax.delete(`${this.resources}/${this.administrator.id}`, {
        contentType: 'application/json, text/javascript',
        responseType: 'json',
        success: () => {
          newAlertify('移除管理员成功', {
            type: 'success'
          });
          return this.$emit('deletedAdministrator', this.administrator);
        },
        error: function() {
          return newAlertify('移除管理员失败', {
            type: 'error'
          });
        }
      });
    },
    showUserInfoModal: function() {
      return new UserModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('user_modal_container'),
        propsData: {
          organization: this.organization,
          administrator: this.administrator,
          accessesList: this.accessesList,
          founded: this.founded,
          profileSchema: this.profileSchema,
          statusChangeCallback: (access) => {
            return this.accessChange(access);
          }
        }
      });
    },
    _updateAccess: function(data, access) {
      return Skylark.Libs.Ajax.put(`${this.resources}/${this.administrator.id}`, {
        contentType: 'application/json, text/javascript',
        responseType: 'json',
        data: data,
        success: () => {
          newAlertify('角色修改成功', {
            type: 'success'
          });
          return this.administrator.access.name = access.name;
        },
        error: function() {
          return newAlertify('角色修改失败', {
            type: 'error'
          });
        }
      });
    }
  }
};
